// 各プランの対象日(開始日, 終了日)を定義
const PLAN_WINDOWS = {
  "5日発送":  { start: 21, end: 31 }, // 21日〜月末
  "15日発送": { start: 1,  end: 10 }, // 1日〜10日
  "25日発送": { start: 11, end: 20 }, // 11日〜20日
};

let observer; // MutationObserverをグローバルで保持

function isPlanValidToday(planName) {
  if (!planName) return true;

  // 「◯日発送」の部分を正確に抜き出す(例:「25日発送」)
  const match = planName.match(/(\d+)日発送/);
  if (!match) return true; // 該当パターンが無ければ通常商品としてスルー

  const matchedKey = match[0]; // 例: "25日発送"
  const window = PLAN_WINDOWS[matchedKey];
  if (!window) return true; // 定義していないプラン名ならスルー

  const today = new Date().getDate();

  if (window.start <= window.end) {
    return today >= window.start && today <= window.end;
  } else {
    return today >= window.start || today <= window.end;
  }
}

function checkCartValidity() {
  // 自分自身のDOM変更でMutationObserverが再発火しないよう、一時的に監視を止める
  if (observer) observer.disconnect();

  const cartItems = document.querySelectorAll('.cart-item');
  const checkoutButton = document.getElementById('checkout');
  let hasInvalidItem = false;

  cartItems.forEach(function(item) {
    // 既存の警告を一旦リセット(再チェック時の重複防止)
    const oldWarning = item.querySelector('.cart-item-warning');
    if (oldWarning) oldWarning.remove();
    item.style.border = '';

    const planName = item.dataset.sellingPlanName;
    if (planName && !isPlanValidToday(planName)) {
      hasInvalidItem = true;

      const warning = document.createElement('div');
      warning.className = 'cart-item-warning';
      warning.style.color = 'red';
      warning.style.fontSize = '0.9em';
      warning.style.marginTop = '4px';
      warning.textContent = 'こちらの商品は現在ご購入いただけない期間です。カートから削除するか、プランを選び直してください。';

      const detailsCell = item.querySelector('.cart-item__details');
      if (detailsCell) detailsCell.appendChild(warning);

      item.style.border = '2px solid red';
    }
  });

  if (checkoutButton) {
    checkoutButton.disabled = hasInvalidItem;
    checkoutButton.style.opacity = hasInvalidItem ? '0.5' : '';
    checkoutButton.style.cursor = hasInvalidItem ? 'not-allowed' : '';
  }

  // チェック処理が終わったら監視を再開
  const cartItemsContainer = document.getElementById('main-cart-items');
  if (observer && cartItemsContainer) {
    observer.observe(cartItemsContainer, { childList: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  checkCartValidity();

  const cartItemsContainer = document.getElementById('main-cart-items');
  if (cartItemsContainer) {
    observer = new MutationObserver(function() {
      checkCartValidity();
    });
    observer.observe(cartItemsContainer, { childList: true, subtree: true });
  }
});